/* global document */
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { BulletPoint, OpenBlue } from "../../../assets/icons";
import { Button } from "@fluentui/react-components";
import { STARTER_PRESENTATION_PATH, STARTER_PRESENTATION_FILENAME } from "../../../constants/downloads";
import { showDownloadStep } from "../../../state/joyrideSlice";

const BulletsStep = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleTutorialClick = () => {
    const link = document.createElement("a");
    link.href = STARTER_PRESENTATION_PATH;
    link.download = STARTER_PRESENTATION_FILENAME;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    dispatch(showDownloadStep());
  };

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 4fr", textAlign: "left" }}>
      <div></div>
      <p style={{ margin: "0px" }}>{t("walkthrough.4of4")}</p>
      <div></div>
      <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0px" }}>{t("walkthrough.bullets.title")}</p>
      <BulletPoint style={{ justifySelf: "center" }} />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <p style={{ textAlign: "left", margin: "0px" }}>{t("walkthrough.bullets.content1")}</p>
        <p style={{ textAlign: "left", margin: "0px", marginTop: "16px" }}>
          {t("walkthrough.bullets.content2")}
          <Button onClick={handleTutorialClick} style={{ justifyContent: "left" }}>
            <span style={{ color: "#0065FD" }}>{t("walkthrough.tutorial")}</span>{" "}
            <OpenBlue style={{ width: "16px", height: "16px" }} />
          </Button>
        </p>
      </div>
    </div>
  );
};

export default BulletsStep;
